module.exports = __webpack_public_path__ + "static/profile-pic-242cdcf6e056de53b1d9610225f33dbd.png";